import { useContext, useState } from "react";
import { AlertContext } from "../context/AlertContext";
import { domain } from "../consts";
import EditableImage from "./EditableImage.jsx";
import EditableText from "./EditableText.jsx";
const InvitationHero = ({ rsvp, isEditable = false, onUpdate }) => {
  const { handleAlert } = useContext(AlertContext);
  const [isUploadingHeader, setIsUploadingHeader] = useState(false);
  const defaultImage =
    "https://bucket.pozivnica.hr/pozivnica/pexels-photo-2253870.webp";
  const imageUrl = rsvp?.headerImage || defaultImage;

  return (
    <div className="relative w-full">
      <EditableImage
        imageUrl={imageUrl}
        defaultImage={defaultImage}
        onImageChange={(updates) => onUpdate(updates)}
        isEditable={isEditable}
        className="w-full h-full object-cover"
        imageType="headerImage"
        setIsUploading={setIsUploadingHeader}
        isUploading={isUploadingHeader}
        handleAlert={handleAlert}
        domain={domain}
        includeImage={rsvp.includeHeaderImage}
        texture={rsvp.texture}
      />
      <div
        className={
          rsvp.includeHeaderImage
            ? `absolute inset-0 flex flex-col items-center justify-center p-4 ${
                rsvp?.texture
                  ? rsvp?.eventName === "Elizabeta i Juraj"
                    ? "-top-14 mt-0"
                    : "top-0 mt-0"
                  : rsvp?.eventName === "Elizabeta i Juraj"
                  ? "-top-12 mt-0"
                  : "top-0 mt-20"
              }`
            : `flex flex-col items-center justify-center p-4 mt-10`
        }
      >
        <EditableText
          text={rsvp?.eventName}
          onTextChange={(text) => onUpdate({ eventName: text })}
          className={`font-bold font-${rsvp.titleFont} text-center`}
          style={{ color: rsvp.titleColor }}
          font={rsvp.titleFont}
          color={rsvp.titleColor}
          fontSize={rsvp.titleFontSize}
          onStyleChange={(style) => {
            if (style.font) onUpdate({ titleFont: style.font });
            if (style.color) onUpdate({ titleColor: style.color });
            if (style.fontSize) onUpdate({ titleFontSize: style.fontSize });
            if (style.isBold !== undefined)
              onUpdate({ titleIsBold: style.isBold });
            if (style.isItalic !== undefined)
              onUpdate({ titleIsItalic: style.isItalic });
          }}
          tag="h1"
          isEditable={isEditable}
          isBold={rsvp.titleIsBold}
          isItalic={rsvp.titleIsItalic}
        />
        <EditableText
          text={
            rsvp?.date ? new Date(rsvp.date).toLocaleDateString("hr-HR") : ""
          }
          onTextChange={(text) => {
            try {
              const [day, month, year] = text.split(".");
              const date = new Date(year, month - 1, day);
              if (!isNaN(date.getTime())) {
                onUpdate({ date: date.toISOString() });
              }
            } catch (error) {
              console.error("Invalid date format");
            }
          }}
          className={`font-${rsvp.dateFont}`}
          style={{ color: rsvp.dateColor }}
          font={rsvp.dateFont}
          color={rsvp.dateColor}
          fontSize={rsvp.dateFontSize}
          onStyleChange={(style) => {
            if (style.font) onUpdate({ dateFont: style.font });
            if (style.color) onUpdate({ dateColor: style.color });
            if (style.fontSize) onUpdate({ dateFontSize: style.fontSize });
            if (style.isBold !== undefined)
              onUpdate({ dateIsBold: style.isBold });
            if (style.isItalic !== undefined)
              onUpdate({ dateIsItalic: style.isItalic });
          }}
          isEditable={isEditable}
          isBold={rsvp.dateIsBold}
          isItalic={rsvp.dateIsItalic}
        />
      </div>
    </div>
  );
};

export default InvitationHero;
